<template>
  <div class="services-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="section-container">
        <h1 class="page-header__title">Layanan Kami</h1>
        <div class="page-header__breadcrumb">
          <router-link to="/miraverse">Miraverse.ID</router-link>
          <span>/</span>
          <span>Layanan</span>
        </div>
      </div>
    </div>

    <!-- Services List -->
    <section class="section">
      <div class="section-container">
        <div class="section-title animate-on-scroll">
          <span class="badge-label">
            <span class="badge-label__dot"></span>
            Apa yang Kami Tawarkan
          </span>
          <h2>Berbagai Solusi IT untuk <span class="text-gradient">Transformasi Digital</span></h2>
          <p class="section-subtitle">Solusi lengkap untuk mendukung pertumbuhan bisnis Anda di era digital.</p>
        </div>

        <div class="services-detail-grid">
          <div v-for="(service, index) in services" :key="index" class="service-detail-card animate-on-scroll"
            :class="'delay-' + ((index % 3) + 1)">
            <div class="service-detail-card__icon">
              <i :class="service.icon"></i>
            </div>
            <div class="service-detail-card__content">
              <h3>{{ service.title }}</h3>
              <p class="service-detail-card__tagline">{{ service.tagline }}</p>
              <p class="service-detail-card__desc">{{ service.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Process Section -->
    <section class="section section--alt">
      <div class="section-container">
        <div class="section-title animate-on-scroll">
          <span class="badge-label">
            <span class="badge-label__dot"></span>
            Proses Kerja
          </span>
          <h2>Bagaimana Kami <span class="text-gradient">Bekerja</span></h2>
        </div>
        <div class="process-grid animate-on-scroll">
          <div class="process-step" v-for="(step, index) in process" :key="index">
            <div class="process-step__number">{{ String(index + 1).padStart(2, '0') }}</div>
            <h4>{{ step.title }}</h4>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="section section--gradient">
      <div class="section-container">
        <div class="services-cta animate-on-scroll">
          <h2>Tertarik dengan layanan kami?</h2>
          <p>Hubungi kami untuk konsultasi gratis dan temukan solusi terbaik untuk bisnis Anda.</p>
          <router-link to="/contact" class="btn-primary-custom" style="background: #fff; color: #6C2973;">Konsultasi
            Gratis</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesPage',
  data() {
    return {
      services: [
        {
          icon: 'fa fa-globe',
          title: 'Pengembangan Company Website',
          tagline: 'Website yang Menarik, Bisnis yang Berkembang!',
          description: 'Buat kesan pertama yang tak terlupakan dengan website profesional kami. Didesain khusus untuk meningkatkan visibilitas dan kredibilitas bisnis Anda, siap menarik perhatian pelanggan baru. Mulailah perjalanan digital Anda hari ini!'
        },
        {
          icon: 'fa fa-mobile',
          title: 'Pengembangan Aplikasi Web dan Mobile',
          tagline: 'Aplikasi Inovatif untuk Semua Platform!',
          description: 'Raih pelanggan Anda di mana saja dengan aplikasi web dan mobile yang user-friendly. Dari konsep hingga peluncuran, kami hadir untuk mengubah ide Anda menjadi aplikasi yang berfungsi dengan baik dan menarik. Mari ciptakan pengalaman pengguna yang luar biasa bersama!'
        },
        {
          icon: 'fa fa-cogs',
          title: 'Pengembangan Sistem ERP',
          tagline: 'Optimalkan Operasional Bisnis Anda!',
          description: 'Sistem ERP kami dirancang untuk menyederhanakan proses dan meningkatkan efisiensi. Integrasikan semua fungsi bisnis Anda dalam satu platform yang mudah diakses dan dikelola. Transformasi cara kerja Anda dan capai tujuan dengan lebih cepat!'
        },
        {
          icon: 'fa fa-handshake-o',
          title: 'Pengembangan Sistem CRM',
          tagline: 'Hubungkan dengan Pelanggan Anda Lebih Baik!',
          description: 'Kembangkan hubungan yang lebih kuat dengan pelanggan melalui sistem CRM kami. Dapatkan wawasan mendalam tentang perilaku pelanggan dan tingkatkan pengalaman mereka. Tingkatkan loyalitas dan penjualan dengan solusi yang disesuaikan untuk kebutuhan Anda!'
        },
        {
          icon: 'fa fa-whatsapp',
          title: 'Penyedia Layanan Notifikasi WhatsApp Business Platform dari Meta',
          tagline: 'Komunikasi yang Lebih Mudah dan Efisien!',
          description: 'Raih pelanggan Anda dengan notifikasi WhatsApp yang tepat waktu dan relevan. Layanan kami memungkinkan Anda berkomunikasi secara langsung dengan audiens Anda, meningkatkan keterlibatan dan kepuasan pelanggan. Koneksikan bisnis Anda dengan cara yang lebih personal!'
        },
        {
          icon: 'fa fa-cloud',
          title: 'Cloud & Domain Provider',
          tagline: 'Solusi Cloud dan Domain untuk Masa Depan Anda!',
          description: 'Dapatkan kehadiran online yang kuat dengan layanan cloud dan domain kami. Fleksibel, aman, dan dapat diandalkan, kami membantu Anda mengelola sumber daya digital Anda dengan mudah. Mulai perjalanan digital Anda sekarang dengan solusi kami yang terintegrasi!'
        }
      ],
      process: [
        { title: 'Konsultasi', desc: 'Diskusikan kebutuhan dan tujuan bisnis Anda bersama tim ahli kami.' },
        { title: 'Perencanaan', desc: 'Kami merancang solusi yang disesuaikan dengan kebutuhan spesifik Anda.' },
        { title: 'Pengembangan', desc: 'Tim kami mengembangkan solusi dengan teknologi terkini dan best practices.' },
        { title: 'Peluncuran & Dukungan', desc: 'Peluncuran proyek dan dukungan teknis berkelanjutan untuk kesuksesan Anda.' }
      ]
    }
  },
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { entry.target.classList.add('animated') }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.text-gradient {
  background: linear-gradient(135deg, #6C2973, #C73468);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.services-detail-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.service-detail-card {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 28px;
  background: #fff;
  border-radius: 20px;
  padding: 36px;
  box-shadow: 0 4px 20px rgba(108, 41, 115, 0.06);
  border: 1px solid rgba(108, 41, 115, 0.06);
  transition: all 0.35s ease;

  &:hover {
    transform: translateX(8px);
    box-shadow: 0 8px 30px rgba(108, 41, 115, 0.12);
    border-color: rgba(199, 52, 104, 0.15);
  }
}

.service-detail-card__icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(108, 41, 115, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #6C2973;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.service-detail-card:hover .service-detail-card__icon {
  background: linear-gradient(135deg, #6C2973, #C73468);
  color: #fff;
}

.service-detail-card__content {
  h3 {
    font-size: 1.25rem;
    margin-bottom: 6px;
  }
}

.service-detail-card__tagline {
  color: #C73468;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.service-detail-card__desc {
  color: $text-body;
  line-height: 1.8;
  font-size: 0.95rem;
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.process-step {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(108, 41, 115, 0.06);
  transition: all 0.3s ease;
  border: 1px solid rgba(108, 41, 115, 0.06);
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(108, 41, 115, 0.12);
  }

  h4 {
    margin: 16px 0 10px;
  }

  p {
    font-size: 0.88rem;
    color: $text-body;
    line-height: 1.7;
  }
}

.process-step__number {
  font-size: 2.2rem;
  font-weight: 800;
  background: linear-gradient(135deg, #6C2973, #C73468);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.services-cta {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;

  h2 {
    color: #fff;
    margin-bottom: 16px;
  }

  p {
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 28px;
  }
}

@media (max-width: 991px) {
  .process-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 767px) {
  .service-detail-card {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 24px;
  }

  .process-grid {
    grid-template-columns: 1fr;
  }
}
</style>